export const repGroups = "repGroups";
export const vendors = "vendors";
export const brands = "brands";
export const warehouses = "warehouses";
export const productLines = "productLines";
export const collections = "collections";
export const productCategories = "categories";
export const productSubCategories = "productSubCategories";
export const productSuperCategories = "productSuperCategories";
export const categories = "categories";
export const subcategories = "subcategories";
export const supercategories = "supercategories";
export const customSource1 = "customSource1";
export const source = "source";
export const insideSales = "";
export const vendorsShowInactive = "";
export const defaultOrderStatuses = [];
export const exportedOrdersOnly = false;
export const salesGroup = "";
export const locationType = "";
export const customerCategory = "customerCategory";

export default {
	transactionTypes: [
		{
			value: "Order",
			label: "Order"
		},
		{
			value: "Quote",
			label: "Quote"
		},
		{
			value: "Sample",
			label: "Sample"
		}
	],
	erpStatuses: [
		{
			value: "Open",
			label: "Open"
		},
		{
			value: "Shipped",
			label: "Shipped"
		}
	],
	openLineStatuses: [
		{
			value: "Open",
			label: "Open"
		},
		{
			value: "On Hold",
			label: "On Hold"
		}
	],
	lineStatuses: [
		{
			value: "Open",
			label: "Open"
		},
		{
			value: "On Hold",
			label: "On Hold"
		},
		{
			value: "Completed",
			label: "Completed"
		},
		{
			value: "Review",
			label: "Review"
		}
	],
	customerStatuses: [
		{
			value: "Active",
			label: "Active"
		},
		{
			value: "InActive",
			label: "InActive"
		}
	],
	defaultOrderStatuses: [

	],
	dataAnalysisReports: [
		{
			value: "ByCustomer",
			label: "Sold To"
		},
		{
			value: "ByShipLocation",
			label: "Dealer"
		},
		{
			value: "ByProduct",
			label: "Product"
		},
		{
			value: "ByProductLine",
			label: "Product Line"
		},
		{
			value: "ByProductCategory",
			label: "Product Category"
		},
		{
			value: "ByProductSubCategory",
			label: "Product Sub Category"
		},
		{
			value: "ByProductSuperCategory",
			label: "Product Super Category"
		},
		{
			value: "ByOrderSource",
			label: "Order Source"
		},
		{
			value: "ByRepGroup",
			label: "Rep Group"
		},
		{
			value: "BySalesRep",
			label: "Sales Rep"
		}
	],
	reports: [
		{
			name: "DataAnalysis_DataAnalysis",
			reportName: "DataAnalysis",
			output: "xlsx",
			cellLoad: "A5",
			reformat: false,
			requiredParams: [source, "dataAnalysisReports"],
			params: [
				"dateRange",
				source,
				"billTo",
				"repID",
				productLines,
				"dataAnalysisReports"
			]
		},
		{
			name: "DataAnalysis_SalesAnalysisReport",
			reportName: "SalesAnalysisReport",
			output: "xlsx",
			startDate: moment(),
			params: ["startDate", "repID"]
		},
		{
			name: "DataAnalysis_VendorCustomerSummary",
			reportName: "VendorCustomerSummary",
			output: "xlsx",
			startDate: moment()
				.startOf("year")
				.subtract(1, "year"),
			endDate: moment().subtract(1, "year"),
			startDate2: moment().startOf("year"),
			endDate2: moment(),
			params: [
				"startDate",
				"endDate",
				"startDate2",
				"endDate2",
				"showCode",
				"accountType",
				"location",
				"orderStatuses",
				vendors,
				vendorsShowInactive,
				"orderSource",
				"repType",
				"repID",
				productLines,
				productCategories,
				"groupbyVendor",
				"groupbyShipTo",
				"exported",
				insideSales
			],
			defaultParams: [
				{
					key: "orderStatuses",
					value: ["Open", "Completed", "Review"]
				},
				{
					key: "exported",
					value: exportedOrdersOnly
				}
			]
		},
		{
			name: "DataAnalysis_VendorTotalByDateRange",
			reportName: "VendorTotalByDateRange",
			output: "xlsx",
			startDate: moment()
				.startOf("year")
				.subtract(1, "year"),
			endDate: moment().subtract(1, "year"),
			startDate2: moment().startOf("year"),
			endDate2: moment(),
			params: [
				"startDate",
				"endDate",
				"startDate2",
				"endDate2",
				"showCode",
				"orderStatuses",
				vendors,
				vendorsShowInactive,
				"orderSource",
				"repType",
				"repID",
			],
			defaultParams: [
				{
					key: "orderStatuses",
					value: ["Open", "Completed", "Review"]
				},
				{
					key: "exported",
					value: exportedOrdersOnly
				}
			]
		},
		{
			name: "DataAnalysis_CustomerBrandSummary",
			reportName: "CustomerBrandSummary",
			output: "xlsx",
			startDate: moment()
				.startOf("year")
				.subtract(1, "year"),
			endDate: moment().subtract(1, "year"),
			startDate2: moment().startOf("year"),
			endDate2: moment(),
			params: [
				"startDate",
				"endDate",
				"startDate2",
				"endDate2",
				"showCode",
				"orderStatuses",
				productCategories,
				customSource1,
				"orderSource",
				"repID",
				productLines,
				"groupByBrandGroup",
				"groupByBrand",
				"groupbyShipTo"
			],
			defaultParams: [
				{
					key: "orderStatuses",
					value: ["Open", "Completed", "Review"]
				}
			]
		},
		{
			name: "DataAnalysis_VendorCategorySummary",
			reportName: "VendorCategorySummary",
			output: "xlsx",
			cellLoad: "A4",
			reformat: false,
			groupByRegion: true,
			includeParams: true,
			startDate: moment()
				.startOf("year")
				.subtract(1, "year"),
			endDate: moment().subtract(1, "year"),
			startDate2: moment().startOf("year"),
			endDate2: moment(),
			params: [
				"startDate",
				"endDate",
				"startDate2",
				"endDate2",
				vendors,
				vendorsShowInactive,
				"repID",
				productCategories,
				"customer",
				"groupbyRep",
				"groupByCustomer"
			],
			defaultParams: [
				{
					key: "repType",
					value: "SALESREP"
				}
			]
		},
		{
			name: "DataAnalysis_CommissioningTotals",
			reportName: "CommissioningTotals",
			output: "xlsx",
			period1Start: moment().subtract(1, "month"),
			period1End: moment(),
			period2Start: moment().subtract(1, "year").subtract(1, "month"),
			period2End: moment().subtract(1, "year"),
			period3Start: moment().subtract(1, "month"),
			period3End: moment(),
			period4Start: moment().subtract(1, "year").subtract(1, "month"),
			period4End: moment().subtract(1, "year"),
			params: [
				"period1Start",
				"period1End",
				"period2Start",
				"period2End",
				"period3Start",
				"period3End",
				"period4Start",
				"period4End",
				"accountType",
				"keyAccountGroup",
				"orderStatuses",
				vendors,
				"orderSource",
				"repType",
				"repID",
				"reportByPaidSales",
				"groupByDivision",
				"groupByRegion",
				"groupByVendor",
				"groupByPaidRep",
				"groupBySalesRep",
				"groupByParentVendor",
				"groupByParentCustomer",
				"groupByCustomer",
				"promoCodes"
			],
			defaultParams: [
				{
					key: "orderStatuses",
					value: ["Open", "Completed", "Review"]
				},
				{
					key: "groupByVendor",
					value: false
				}
			]
		},
		{
			name: "DataAnalysis_ProductSummary",
			reportName: "ProductSummary",
			output: "xlsx",
			startDate: moment().startOf("year"),
			endDate: moment(),
			params: [
				"startDate",
				"endDate",
				"showCode",
				"productDescription",
				"productTags",
				"location",
				"orderStatuses",
				vendors,
				vendorsShowInactive,
				"orderSource",
				"promoCodes",
				"repType",
				"repID",
				"customer",
				"productID",
				productLines,
				productCategories,
				"groupbyCustomer",
				"groupbyRep",
				"exported",
				salesGroup
			],
			defaultParams: [
				{
					key: "orderStatuses",
					value: ["Open", "Completed", "Review"]
				},
				{
					key: "exported",
					value: exportedOrdersOnly
				}
			]
		},
		{
			name: "SalesOrders_TwosCreditHoldOrderSummary",
			reportName: "TwosCreditHoldOrderSummary",
			output: "xlsx",
			cellLoad: "A5",
			reformat: false,
			params: []
		},
		{
			name: "SalesOrders_OrderSummary",
			reportName: "OrderSummary",
			reformat: false,
			params: [
				"billTos",
				"shipTos",
				"startDate",
				"endDate",
				"repID",
				productLines,
				vendors,
				vendorsShowInactive,
				warehouses,
				"shipStartDate",
				"shipEndDate",
				"orderStatuses",
				"erpStatuses",
				"lineStatuses",
				"orderSource",
				"showCode",
				"orderNumber",
				"poNumber",
				"exportedOrdersOnly",
				"output"
			],
			defaultParams: [
				{
					key: "orderStatuses",
					value: ["Open", "On Hold", "Complete", "Completed", "Review"]
				},
				{
					key: "exportedOrdersOnly",
					value: exportedOrdersOnly
				}
			]
		},
		{
			name: "SalesOrders_OrderSummaryV2",
			reportName: "OrderSummaryV2",
			output: "xlsx",
			cellLoad: "A5",
			reformat: false,
			params: [
				"billTos",
				"shipTos",
				"startDate",
				"endDate",
				"repID",
				vendors,
				vendorsShowInactive,
				"shipStartDate",
				"shipEndDate",
				"orderStatuses",
				"erpStatuses",
				"lineStatuses",
				"orderSource",
				"orderNumber",
				"poNumber"
			]
		},
		{
			name: "SalesOrders_OrderDetails",
			reportName: "OrderDetails",
			reformat: false,
			params: [
				"billTos",
				"shipTos",
				"startDate",
				"endDate",
				"repID",
				"exportedOrdersOnly",
				vendors,
				vendorsShowInactive,
				productLines,
				productCategories,
				warehouses,
				"shipStartDate",
				"shipEndDate",
				"orderStatuses",
				"erpStatuses",
				"lineStatuses",
				"orderSource",
				"showCode",
				"orderNumber",
				"poNumber",
				"output"
			],
			defaultParams: [
				{
					key: "orderStatuses",
					value: ["Open", "On Hold", "Complete", "Completed", "Review"]
				},
				{
					key: "exportedOrdersOnly",
					value: exportedOrdersOnly
				}
			]
		},
		{
			name: "SalesOrders_MudPieOrderDetails",
			reportName: "MudPieOrderDetails",
			reformat: false,
			params: [
				"billTos",
				"shipTos",
				"startDate",
				"endDate",
				"repID",
				"exportedOrdersOnly",
				vendors,
				vendorsShowInactive,
				productLines,
				warehouses,
				"shipStartDate",
				"shipEndDate",
				"orderStatuses",
				"erpStatuses",
				"lineStatuses",
				"orderSource",
				"showCode",
				"orderNumber",
				"poNumber",
				productLines,
				"output"
			],
			defaultParams: [
				{
					key: "orderStatuses",
					value: ["Open", "On Hold", "Complete", "Completed", "Review"]
				},
				{
					key: "exportedOrdersOnly",
					value: exportedOrdersOnly
				}
			]
		},
		{
			name: "SalesOrders_OrderSummaryByDate",
			reportName: "OrderSummaryByDate",
			output: "xlsx",
			params: [
				"orderSource",
				"orderStatuses",
				"showCode",
				vendors,
				vendorsShowInactive,
				"startDate",
				"endDate"
			],
			defaultParams: [
				{
					key: "orderStatuses",
					value: defaultOrderStatuses
				}
			]
		},
		{
			name: "SalesOrders_ProductSalesByStatus",
			reportName: "ProductSalesByStatus",
			params: [
				"orderSource",
				"orderStatuses",
				"erpStatuses",
				"showCode",
				"exportedOrdersOnly",
				vendors,
				vendorsShowInactive,
				"startDate",
				"endDate",
				"output"
			],
			defaultParams: [
				{
					key: "orderStatuses",
					value: ["Open", "On Hold", "Complete", "Completed", "Review"]
				},
				{
					key: "exportedOrdersOnly",
					value: exportedOrdersOnly
				}
			]
		},
		{
			name: "SalesOrders_CancelledItemsReport",
			reportName: "CancelledItemsReport",
			reformat: false,
			output: "xlsx",
			params: [
				"startDate",
				"endDate",
				"repID",
				"customer"
			],
		},
		{
			name: "SalesOrders_TopSellingItems",
			reportName: "TopSellingItems",
			imageFromBucket: "True",
			params: [
				"customer",
				"shipID",
				"exportedOrdersOnly",
				vendors,
				vendorsShowInactive,
				warehouses,
				productLines,
				productCategories,
				"subcategories",
				"priceList",
				"source",
				// "supercategories",
				"productSuperCategories",
				"orderSource",
				"orderStatuses",
				"showCode",
				"startDate",
				"endDate",
				"includeImages",
				"top",
				"sortBy",
				"output"
			],
			defaultParams: [
				{
					key: "orderStatuses",
					value: ["Open", "On Hold", "Complete", "Completed", "Review"]
				},
				{
					key: "exportedOrdersOnly",
					value: exportedOrdersOnly
				}
			]
			//,rekey: {
			//  subcategories: "productSubCategories"
			//}
		},
		{
			name: "SalesOrders_OpenOrders",
			reportName: "OpenOrders",
			output: "pdf",
			imageFromBucket: "True",
			//requiredParams: [
			//  "billTos"
			//],
			params: ["billTos", "shipID", "repID", "startDate", "endDate"]
		},
		{
			name: "Products_DetailSheet",
			reportName: "ProductDetailSheet",
			output: "pdf",
			params: [
				"ProductID",
				"Description",
				"ProductLines",
				categories,
				subcategories,
				supercategories,
				vendors,
				vendorsShowInactive,
				"priceList",
				"priceText",
				"priceOverwrite",
				"inStockOnly"
			],
			defaultParams: [
				{
					key: "priceOverwrite",
					value: ""
				},
				{
					key: "priceList",
					value: ""
				},
				{
					key: "priceText",
					value: ""
				}
			]
		},
		{
			name: "SalesOrders_OrderWriterSummary",
			reportName: "OrderWriterSummary",
			params: ["startDate", "endDate"]
		},
		{
			name: "Invoices_InvoiceShipments",
			reportName: "InvoiceShipments",
			params: ["startDate", "endDate", "shipStartDate", "shipEndDate"]
		},
		{
			name: "Invoices_InvoiceShipments",
			reportName: "InvoiceShipments",
			params: ["startDate", "endDate", "shipStartDate", "shipEndDate"]
		},
		{
			name: "Invoices_JR045ShipmentsByAccount",
			reportName: "JR045ShipmentsByAccount",
			output: "pdf",
			params: [
				"billTos",
				"shipTos",
				"startDate",
				"endDate",
				//"startDate2",
				//"endDate2",
				"output"
			]
		},
		{
			name: "SalesOrders_JR045OpenAndHoldOrderItemDetailBill",
			reportName: "JR045OpenAndHoldOrderItemDetailBill",
			output: "pdf",
			params: [
				"billTos",
				"repID",
				"startDate",
				"endDate",
				"includeImages"
			]
		},
		{
			name: "SalesOrders_JR045OpenAndHoldOrderItemDetailShip",
			reportName: "JR045OpenAndHoldOrderItemDetailShip",
			output: "pdf",
			params: [
				"billTos",
				"repID",
				"startDate",
				"endDate",
				"includeImages"
			]
		},
		{
			name: "Invoices_InvoicesSummary",
			reportName: "InvoiceSummary",
			reformat: false,
			params: [
				"billTos",
				"shipTos",
				"repID",
				"invoiceType",
				productLines,
				vendors,
				vendorsShowInactive,
				customerCategory,
				"startDate",
				"endDate",
				"output"
			]
		},
		{
			name: "Invoices_InvoiceDetails",
			reportName: "InvoiceDetails",
			params: [
				"billTos",
				"shipTos",
				productLines,
				vendors,
				vendorsShowInactive,
				customerCategory,
				"startDate",
				"endDate",
				"output"
			]
		},
		{
			name: "Invoices_InvoicesSummaryV2",
			reportName: "InvoiceSummaryV2",
			output: "xlsx",
			cellLoad: "A5",
			reformat: false,
			params: [
				"billTos",
				"shipTos",
				productLines,
				"startDate",
				"endDate",
				customerCategory
			]
		},
		{
			name: "SalesOrders_DealerPurchaseHistory",
			reportName: "DealerPurchaseHistory",
			params: [
				"billTo",
				"shipTo",
				brands,
				categories,
				collections,
				supercategories,
				"groupBySubCategory",
				"includeImages",
				"output"
			]
		},
		{
			name: "SalesOrders_RepPerformance",
			reportName: "RepPerformance",
			output: "xlsx",
			instructions: "This report is based on bookings.",
			params: ["repID", "repPerformanceRange"]
		},
		{
			name: "SalesOrders_TotalSalesByDate",
			reportName: "TotalSalesByDate",
			params: [
				"orderSource",
				"orderStatuses",
				"erpStatuses",
				"showCode",
				"exportedOrdersOnly",
				vendors,
				vendorsShowInactive,
				"startDate",
				"endDate",
				"output"
			],
			defaultParams: [
				{
					key: "orderStatuses",
					value: ["Open", "On Hold", "Complete", "Completed", "Review"]
				},
				{
					key: "exportedOrdersOnly",
					value: exportedOrdersOnly
				}
			]
		},
		{
			name: "SalesOrders_VendorSalesSummary",
			reportName: "VendorSalesSummary",
			params: ["startDate", "endDate"]
		},
		{
			name: "SalesOrders_TwosTotalsData",
			reportName: "TwosTotalsData",
			output: "xlsx",
			params: []
		},
		{
			name: "Customers_DealerList",
			reportName: "DealerList",
			params: ["accountType", locationType, insideSales,"repID","customerCreatedStartDate", "customerCreatedEndDate", "output"]
		},
		{
			name: "DEM233DealerList",
			reportName: "DEM233DealerList",
			params: ["accountType", insideSales, "output"]
		},
		{
			name: "Customers_TwosCustomerDrop",
			reportName: "TwosCustomerDrop",
			output: "xlsx",
			params: []
		},
		{
			name: "Customers_ProspectDrop",
			reportName: "ProspectDrop",
			output: "xlsx",
			params: []
		},
		{
			name: "Customers_CustomerException",
			reportName: "CustomerException",
			output: "xlsx",
			params: ["startDate", "endDate"]
		},
		{
			name: "Products_ProductMissingImages",
			reportName: "ProductMissingImages",
			output: "xlsx",
			params: []
		},
		{
			name: "SalesOrders_SalesByProductLine",
			reportName: "SalesByProductLine",
			params: ["startDate", "endDate", "orderStatuses", "erpStatuses"]
		},
		{
			name: "Activities_ActivitySummary",
			reportName: "ActivitySummary",
			output: "xlsx",
			params: ["startDate", "endDate", "activityType"]
		},
		{
			name: "Users_EMUN1UserSessionsData",
			reportName: "EMUN1UserSessionsData",
			startDate: moment().subtract(10, "days"),
			output: "xlsx",
			params: ["startDate", "endDate"]
		},
		{
			name: "Users_EMUN1UserSessionsByLoginDateData",
			reportName: "EMUN1UserSessionsByLoginDateData",
			startDate: moment().subtract(10, "days"),
			output: "xlsx",
			params: ["startDate", "endDate"]
		},
		{
			name: "Users_EMUN1ActiveUsersData",
			reportName: "EMUN1ActiveUsersData",
			output: "xlsx",
			startDate: moment().subtract(10, "years"),
			params: ["startDate"]
		},
		{
			name: "Users_EMUN1ActiveUsersDataByDate",
			reportName: "EMUN1ActiveUsersData",
			output: "xlsx",
			startDate: moment().subtract(10, "days"),
			params: ["startDate"]
		},
		{
			name: "Users_EMUN1CorpUserSessionsData",
			reportName: "EMUN1CorpUserSessionsData",
			output: "xlsx",
			startDate: moment().subtract(10, "days"),
			params: ["startDate"]
		},
		{
			name: "Users_EMUN1CorpUserSessionsByLoginDateData",
			reportName: "EMUN1CorpUserSessionsByLoginDateData",
			output: "xlsx",
			startDate: moment().subtract(10, "days"),
			params: ["startDate"]
		},
		{
			name: "Users_EMUN1ResetPassword",
			reportName: "EMUN1ResetPassword",
			output: "xlsx",
			params: []
		},
		{
			name: "Products_TwosProduct",
			reportName: "TwosProduct",
			output: "xlsx",
			params: [],
			cellLoad: "A2",
			reformat: false,
			includeParams: false
		},
		{
			name: "SalesOrders_HKF050DealerSalesAnalysis",
			reportName: "DealerSalesAnalysis",
			params: [
				"billTo",
				"shipTo",
				vendors,
				vendorsShowInactive,
				productLines,
				categories,
				productSubCategories,
				"superCategories",
				"groupBySubCategory",
				"output"
			],
			rekey: {
				[productLines]: "brands",
				[productSubCategories]: collections
			}
		},
		{
			name: "Products_HKF050ItemAvailability",
			reportName: "HKF050ItemAvailability",
			params: [
				"productID",
				"productDescription",
				vendors,
				vendorsShowInactive,
				productLines,
				productCategories,
				"subcategories",
				warehouses,
				//"statuses",
				"inStock",
				"priceList",
				"output"
			],
			rekey: {
				subcategories: "productSubCategories"
			}
		},
		{
			name: "Products_HKF050FactoryItemAvailability",
			reportName: "HKF050FactoryItemAvailability",
			requiredParams: ["priceList", "factory"],
			params: ["priceList", "factory", "output"]
		},
		{
			name: "Products_HKF050FactoryItemPhotoSheet",
			reportName: "HKF050FactoryPhotoSheet",
			requiredParams: ["priceList", "factory"],
			params: ["priceList", "factory", "inStock", "output"]
		},
		{
			name: "Products_HKF050PriceSheet",
			reportName: "HKF050PriceSheet",
			params: [
				"productID",
				"productDescription",
				productLines,
				categories,
				subcategories,
				supercategories,
				vendors,
				vendorsShowInactive,
				"priceList",
				"output"
			]
		},
		{
			name: "Products_PhotoSheet",
			reportName: "PhotoSheet",
			output: "pdf",
			params: [
				"productID",
				"productDescription",
				productLines,
				categories,
				subcategories,
				supercategories,
				vendors,
				vendorsShowInactive,
				"photoSheetLayout",
				"inStockOnly",
			]
		},
		{
			name: "Products_JR045ProductAnalyzer",
			reportName: "JR045ProductAnalyzer",
			output: "xlsx",
			params: [
				"productID",
				"productDescription",
				productLines,
				categories,
				subcategories
			]
		},
		{
			name: "SalesOrders_JR045SalesAnalyzer",
			reportName: "JR045SalesAnalyzer",
			output: "xlsx",
			params: [
				"billTos",
				"shipTos",
				"statuses",
				"shipState",
				"shipZipcode",
				"shipCountry"
			]
		},
		{
			name: "Commissions_CommissionStatementRep",
			reportName: "CommissionStatementRep",
			//output: "pdf",
			params: ["period", "repID", "output"],
			requiredParams: ["period"],
			defaultParams: [
				{
					key: "output",
					value: "pdf"
				}
			]
		},
		{
			name: "Users_CronofyMissingTokens",
			reportName: "CronofyMissingTokens",
			output: "xlsx",
			params: []
		},
		{
			name: "SalesOrders_SalesSummaryByVendor",
			reportName: "SalesSummaryByVendor",
			reformat: false,
			params: ["startDate", "endDate", "orderSource", "orderStatuses", "output"]
		},
		{
			name: "SalesOrders_HunterOrderSummary",
			reportName: "HunterOrderSummary",
			output: "xlsx",
			startDate: moment().subtract(7, "days"),
			reformat: false,
			params: ["startDate", "endDate"]
		},
		{
			name: "CustomerCallReport_Customers",
			reportName: "CustomerCallReport",
			output: "pdf",
			requiredParams: [
				"customer"
			],
			params: ["customer"]
		},
		{
			name: "SalesOrders_SalesRepSummaryByTotalSales",
			reportName: "SalesRepSummaryByTotalSales",
			output: "pdf",
			params: ["startDate", "endDate", "orderStatuses"],
			defaultParams: [
				{
					key: "orderStatuses",
					value: ["Open", "Completed", "Review"]
				}
			]
		},
		{
			name: "SalesOrders_JR045SalesSummaryByProductLine",
			reportName: "JR045SalesSummaryByProductLine",
			output: "pdf",
			params: ["startDate", "endDate", "orderStatuses"],
			defaultParams: [
				{
					key: "orderStatuses",
					value: ["Open", "Completed", "Review"]
				}
			]
		},
		{
			name: "DataAnalysis_MfgInvoiceSummary",
			reportName: "MfgInvoiceSummary",
			output: "xlsx",
			startDate: moment().startOf("year"),
			endDate: moment(),
			params: ["startDate",
				"endDate",
				vendors,
				"period",
				"repID",
				"customer",
				"orderNumber",
				"invoiceNumber",
				"poNumber"],
			requiredParams: ["startDate", "endDate"]
		},
		{
			name: "DataAnalysis_SalesOrderSummary",
			reportName: "SalesOrderSummary",
			output: "xlsx",
			startDate: moment().startOf("year"),
			endDate: moment(),
			shipStartDate: moment().startOf("year"),
			shipEndDate: moment(),
			params: [
				"startDate",
				"endDate",
				"showCode",
				"transactionTypes",
				"terms",
				"repGroup",
				productCategories,
				"erpStatuses",
				vendors,
				productLines,
				"repType",
				"shipStartDate",
				"shipEndDate",
				"customerCreatedStartDate",
				"customerCreatedEndDate",
				"customerFirstOrderStartDate",
				"customerFirstOrderEndDate",
				"region",
				"repID",
				"accountType",
				"orderStatuses",
				"exportedOrdersOnly",
				"shipState",
				"shipZipcode",
				"billState",
				"billZipcode",
				"customer",
				"orderNumber",
				salesGroup,
				"orderSource",
				"promoCodes",
				"poNumber"
			],
			requiredParams: ["startDate", "endDate"],
			defaultParams: [
				{
					key: "orderStatuses",
					value: ["Open", "Completed", "Review"]
				},
				{
					key: "exportedOrdersOnly",
					value: exportedOrdersOnly
				}
			]
		},
		{
			name: "Customers_DemdacoPlatinumCustomers",
			reportName: "DemdacoPlatinumCustomers",
			output: "xlsx",
			params: ["repID"]
		},
		{
			name: "Customers_DemdacoDiamondWillowTree",
			reportName: "DemdacoDiamondWillowTree",
			output: "xlsx",
			params: ["repID"]
		},
		{
			name: "Customers_DemdacoWillowTreeHistory",
			reportName: "DemdacoWillowTreeHistory",
			output: "xlsx",
			params: ["repID"]
		},
		{
			name: "Customers_DemdacoNewAccounts",
			reportName: "DemdacoNewAccounts",
			output: "xlsx",
			params: ["repID"]
		},
		{
			name: "SalesOrders_DemdacoOnHold",
			reportName: "DemdacoOnHold",
			output: "xlsx",
			params: ["repID"]
		},
		{
			name: "SalesOrders_EnescoOpenOrdersReport",
			reportName: "EnescoOpenOrdersReport",
			output: "xlsx",
			params: ["billTo"]
		},
		{
			name: "SalesOrders_OrderAvailability",
			reportName: "CTGOrderAvailability",
			output: "xlsx",
			params: [
				"orderNumber"
			]
		},
		{
			name: "Customers_Documents",
			reportName: "Customer Documents",
			output: "xlsx",
			serviceReport: "true",
			serviceUrl: "DownloadTaxCertificates",
			params: [
				"State",
				"DocType",
			],
			defaultParams: [
				{
					key: "State",
					value: "AL"
				},
				{
					key: "DocType",
					value: "TaxCertificate"
				}
			]
		}
	]
};
